import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/users/create")({
  component: () => (
    <MaskRedirect
      to="/admin/users"
      action="create"
      mask="/admin/users/create"
    />
  ),
});
